// extracted by mini-css-extract-plugin
module.exports = {"container":"WishesPage_container__3zGCY"};